import { Drawer } from 'antd'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Switch, useHistory, useParams } from 'react-router-dom'

import { usePet, patientName, useToggle } from '../../modules'

import Receive from '../reusable/receive'
import { EntryFields } from '../reusable/inputs'
import CompleteNDiscard from '../reusable/completeNDiscard'

const Attached = ({ name, onClose }) => {
    const [entry, setEntry] = useState()

    const history = useHistory()
    const { id } = useParams()

    const [visible, toggleVisible] = useToggle(true)

    const [{ loading, error }, getEntry] = usePet('singleEntry', { id }, { notify: true, callback: ({ data }) => setEntry(data) })

    const reload = () => {
        setEntry()
        getEntry()
    }

    const { user } = useSelector(state => state.application)

    let canEdit = user?.issuperuser || !entry?.filled || (entry.filledBy?._id === user?._id)

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 300)
    }
    
    const [{ loading: compLoading }, completeEntry] = usePet('completeEntry', { id }, { notify: true, callback: (_, notif, ops) => {
        notif('Changes have been saved', ops('success'))
        onClose()
        close()
    }, manual: true, load: { msg: 'Saving changes...' } })
 
    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={
                <div className="w-full text-right">
                    <CompleteNDiscard
                        entry={ entry } 
                        close={ close } 
                        onClose={ onClose } />
                    <button onClick={close} className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
                </div>
            }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">{ name } { entry ? `for ${ patientName(entry?.patient?.name) }` : '' }</p>
            <Receive
                progress
                loading={loading}
                error={error}>
                {
                    <EntryFields
                        reload={ reload }
                        entry={entry}
                        fields={entry?.item?.fields ?? []} />
                }
            </Receive>
            <Switch>
            </Switch>
        </Drawer>
    )
}

export default Attached